import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const PacienteCard = ({ paciente, mostrarBorda }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
      <div className="card h-100">
        <Link
          to={`/Pacientes/PerfilPaciente/${paciente.id}`}
          style={{
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <div className="card-body d-flex flex-column align-items-center justify-content-center p-3">
            <div
              className="position-relative mb-3"
              style={{
                width: '120px',
                height: '120px',
              }}
            >
              {paciente.imageLoading && (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                </div>
              )}
              <img
                ref={imgRef}
                src={
                  isVisible
                    ? paciente.imageUrl || require('../../../assets/img/perfilvazio.png')
                    : require('../../../assets/img/perfilvazio.png')
                }
                alt={`Foto de ${paciente.name}`}
                className="img-fluid rounded-circle"
                style={{
                  width: '120px',
                  height: '120px',
                  objectFit: 'cover',
                  borderColor: mostrarBorda,
                  borderWidth: mostrarBorda ? '4px' : undefined,
                  borderStyle: mostrarBorda ? 'solid' : undefined,
                  opacity: paciente.imageLoading ? 0.3 : 1,
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                }}
              />
            </div>
            <h5
              className="card-title text-center mb-0"
              style={{
                fontSize: '1rem',
                color: '#2c3e50',
                display: '-webkit-box',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                lineHeight: '1.3',
                minHeight: '2.6em',
              }}
            >
              {paciente.name}
            </h5>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default PacienteCard;


